<template>
    <FormInput :context="context">
        <PrimeVueInputToggleButton v-model="value" v-bind="attributes" v-on="$listeners" @blur="context.blurHandler" />
    </FormInput>
</template>

<script>
import FormInputMixin from "@/components/forms/inputs/mixins/FormInputMixin";
import PrimeVueInputToggleButton from "primevue/togglebutton";

export default {
    components: { PrimeVueInputToggleButton },
    mixins: [FormInputMixin],
    props: {
        iconOn: {
            type: String,
            default: "pi pi-check"
        },
        iconOff: {
            type: String,
            default: "pi pi-times"
        },
        labelOn: {
            type: String
        },
        labelOff: {
            type: String
        }
    },
    computed: {
        defaults() {
            return {
                onIcon: this.iconOn,
                offIcon: this.iconOff,
                onLabel: this.labelOn,
                offLabel: this.labelOff,
            };
        },
    },
};
</script>
